/**
 * Sprint 006b (P4-Kanon) — Die eine In-Page-Tab-Navigation.
 *
 * Underline-Anatomie aus admin.tsx ratifiziert (korrekte role=tab-ARIA).
 * Begründung: rounded-Pills sind das FilterPill-Vokabular (= Filter);
 * Underline = Navigation hält die zwei Sprachen getrennt.
 */
import { type ReactNode } from 'react';

export interface TabNavItem {
  id: string;
  label: ReactNode;
  testid?: string;
}

/** Underline-Klassen für Nicht-Button-Tabs (z. B. Cross-Route-Links) im selben Strip. */
export const TAB_LINK_CLASSES =
  'px-4 py-2 text-sm transition-colors border-b-2 -mb-px whitespace-nowrap text-white/50 border-transparent hover:text-white/80';

interface TabNavProps {
  items: TabNavItem[];
  active: string;
  onChange: (id: string) => void;
  /** Zusätzliche Tabs, die keine State-Tabs sind (z. B. Route-Links) — mit TAB_LINK_CLASSES stylen. */
  trailing?: ReactNode;
  className?: string;
  'aria-label'?: string;
}

export function TabNav({ items, active, onChange, trailing, className = '', ...rest }: TabNavProps) {
  return (
    <div
      role="tablist"
      aria-label={rest['aria-label']}
      className={`flex gap-1 border-b border-white/10 mb-6 overflow-x-auto scrollbar-none ${className}`}
    >
      {items.map((item) => (
        <button
          key={item.id}
          role="tab"
          aria-selected={active === item.id}
          onClick={() => onChange(item.id)}
          data-testid={item.testid}
          className={`px-4 py-2 text-sm transition-colors border-b-2 -mb-px whitespace-nowrap ${
            active === item.id
              ? 'text-white border-white'
              : 'text-white/50 border-transparent hover:text-white/80'
          }`}
        >
          {item.label}
        </button>
      ))}
      {trailing}
    </div>
  );
}

export default TabNav;
